import React from "react";

import { Button } from "../../../Buttons";
import StudentHeaderNavDesktop from "./StudentHeaderNavDesktop";
import ParentHeaderNavDesktop from "./ParentHeaderNavDesktop";

import usersService from "../../../../../services/userService";

import "../../header.scss";
import { MainLogo } from "../../../../../assets";

function DesktopHeader({ userInfo, point_earned }) {
  return (
    <header className="desktopHeader">
      <Button
        customClassName="headerLogoBtn"
        onClick={() => usersService.goToMonolith("")}
      >
        <img className="headerLogo" src={MainLogo} alt="Blue Manor Academy" />
      </Button>

      {userInfo?.account_level === "user" && (
        <StudentHeaderNavDesktop userInfo={userInfo} point_earned={point_earned} />
      )}
      {userInfo?.account_level === "manager" && (
        <ParentHeaderNavDesktop userInfo={userInfo} />
      )}
    </header>
  );
}

export default DesktopHeader;
